// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b3aaecd7","515":"21145f1e"}[chunkId] + ".chunk.js";
};